import { EyeOffIcon, EyeOnIcon } from "../../../../Icons";
import { FilterButton, Tooltip } from "../../../../UI";

const ShowPublicFilter = ({ onClick, isActive, t }) => {
  return (
    <Tooltip showOnHover content={t("layer.fieldAlias.showpublic.title")}>
      <FilterButton selected={isActive} onClick={onClick}>
        {isActive ? <EyeOnIcon /> : <EyeOffIcon />}
      </FilterButton>
    </Tooltip>
  );
};

export default ShowPublicFilter;
